<template>
  <div class="d-flex checkbox-lt text-noselect">
    <Checkbox
      v-bind="checkboxProps"
      class="w-100"
    >
      <slot name="label">
        <div class="text_tab_small">
          {{ label }}
        </div>
        <div
          v-if="isPreflop"
          class="tag-normal ml-2 my-auto text-smallest"
          style="--clr-back: var(--clr-black-2)"
        >
          {{ $t('common.postflop_only') }}
        </div>
      </slot>
      <slot name="tooltip">
        <!-- <div class="csst ml-1 z-index_2 mdi mdi-help-circle-outline clr-grey">
          <div class="csst_content clr-white" v-html="tooltip"></div>
        </div> -->
      </slot>
      <slot />

      <template #icon_tooltip_on>
        <div
          v-if="iconTooltips[0]"
          class="csst_content clr-white"
          style="left: -0.5rem; transform: translate(-100%, 0); max-width: 24rem"
          v-html="iconTooltips[0]"
        ></div>
      </template>
      <template #icon_tooltip_off>
        <div
          v-if="iconTooltips[1]"
          class="csst_content clr-white"
          style="left: -0.5rem; transform: translate(-100%, 0); max-width: 24rem"
          v-html="iconTooltips[1]"
        ></div>
      </template>
    </Checkbox>
    <slot :name="checkboxProps.value ? 'after_active' : 'none'" />
  </div>
</template>

<script>
import Checkbox from '@/components/Common/Checkbox/Checkbox'

export default {
  name: 'CheckboxLt',
  components: {
    Checkbox,
  },
  props: {
    checkboxProps: Object,
    hasIconHelp: Boolean,
    isPreflop: Boolean,

    label: String,
    tooltip: [String, Boolean],
    labelTooltip: String,
    iconTooltips: { default: () => [] },
  },
}
</script>
